import { connectNetwork } from 'lib/NetworkProvider'
import { routes, route_from } from 'lib/routes'
import View from 'lib/View'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Card, Placeholder } from 'semantic-ui-react'
import { SEARCH_ACTIONS } from '../actions/search'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import { Category, Empty } from '../components'

const { app, categories, newEl, categoryEdit } = routes

class Categories extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            items: 10,
            selected: this.props.selected ? this.props.selected : {},
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return nextProps
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { deleteCategory } = this.state
        let { isEmployee, workerId, organization } = this.props
        if (
            this.state.page !== prevState.page ||
            this.state.items !== prevState.items ||
            (deleteCategory.fetching !== prevState.deleteCategory.fetching && !deleteCategory.fetching) ||
            organization.data !== prevProps.organization.data
        ) {
            if (isEmployee) {
                this.state.network.getRecentCategoryList(this.state.search.data, workerId, isEmployee)
            } else {
                this.state.network.getCategoryList(this.state.search.data, isEmployee)
            }
        } else if (this.state.search !== prevState.search) {
            if (isEmployee) {
                this.state.network.getRecentCategoryList(this.state.search.data, workerId, isEmployee)
            } else {
                this.state.network.getCategoryList(this.state.search.data, isEmployee)
            }
        }
    }

    next() {
        this.setState({
            page: this.state.page + 1,
        })
    }

    prev() {
        if (this.state.page === 0) return

        this.setState({
            page: this.state.page - 1,
        })
    }

    componentDidMount() {
        let { isEmployee, sub, workerId } = this.props

        let { login } = this.props

        let user = null
        if (login && login.authenticated) {
            user = login.data.user
        }

        let extraTools = []

        if (user && !!user.manage_category) {
            extraTools.push({
                name: 'Crea nuova categoria',
                icon: 'add',
                action: () => {
                    this.props.history.push(route_from(app, categories, newEl, categoryEdit))
                },
            })
        }

        if (!sub) {
            this.props.toolbarResult([
                ...extraTools,
                // Not paginated yet
                // {
                // 	name: '',
                // 	icon: 'arrow left',
                // 	position: 'right',
                // 	action: () => {
                // 		this.prev()
                // 	}
                // },
                // {
                // 	name: '',
                // 	icon: 'arrow right',
                // 	position: 'none',
                // 	action: () => {
                // 		this.next()
                // 	}
                // }
            ])
        }

        if (isEmployee) {
            this.state.network.getRecentCategoryList(this.state.search.data, workerId, isEmployee)
        } else {
            this.state.network.getCategoryList(this.state.search.data, isEmployee)
        }
    }

    renderCategory(key, category) {
        let { selected } = this.state
        let { onChange, selectable, noActions } = this.props

        let extraProps = {}
        if (selectable) {
            extraProps.onClick = (category) => {
                if (onChange) {
                    onChange(category)
                }
                this.setState({ selected: category })
            }
        }

        if (noActions) {
            extraProps.noActions = true
        }

        return <Category {...extraProps} selected={category.id === selected.id} type="full" key={`category_${key}`} category={category} />
    }

    render() {
        let { categories, fetching } = this.state
        let { onChange, selectable, selected, noActions, ...rest } = this.props
        let content = <div />

        if (fetching) {
            let placeholders = []
            for (let i = 0; i < 3; i++) {
                placeholders.push(
                    <Card key={i} style={{ width: '100%', margin: 8 }}>
                        <Card.Content>
                            <Placeholder>
                                <Placeholder.Header image>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Header>
                                <Placeholder.Paragraph>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Paragraph>
                            </Placeholder>
                        </Card.Content>
                    </Card>
                )
            }
            content = (
                <View fullw column>
                    {placeholders}
                </View>
            )
        } else if (categories.category && categories.category.length > 0) {
            content = Object.keys(categories.category).map((key) => {
                let value = categories.category[key]
                return this.renderCategory(key, value)
            })
        } else {
            content = <Empty />
        }

        return (
            <View fullw fullh column style={{ paddingLeft: 20, paddingRight: 20 }} {...rest}>
                {content}
            </View>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let { getCategoryList, getRecentCategoryList, deleteCategory, search, organization, login } = state
    let { isEmployee } = ownProps

    let categoryList = getCategoryList
    if (isEmployee) {
        categoryList = getRecentCategoryList
    }
    return {
        categories: categoryList.data,
        fetching: categoryList.fetching,
        deleteCategory,
        search,
        login,
        organization,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),

        searchRequest: (result) => SEARCH_ACTIONS.request(result, dispatch),
        searchResult: (result) => SEARCH_ACTIONS.result(result, dispatch),
        searchError: (result) => SEARCH_ACTIONS.error(result, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(Categories)))
